<div class="Txt-Deposit-CreditCard">
  <h2>{{ 'CreditCard' | t }}</h2>
  <span>{{ 'desc_deposit_creditcard' | t }}</span>

  <form class="example-form" [formGroup]="creditcardDatas">
    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'f_name' | t }}" formControlName="firstName" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'l_name' | t }}" formControlName="lastName" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'CardNumber' | t }}" type="number" onKeyPress="if(this.value.length==16) return false;" formControlName="cardNumber" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'CCV' | t }}" type="number" onKeyPress="if(this.value.length==3) return false;" formControlName="CCV" />
    </mat-form-field>

    <div>
      <label style="font-size: 13px">{{ 'Exp_Date' | t }}</label>
    </div>

    <mat-form-field style="width: 45%; margin-right: 10%">
      <input matInput required placeholder="{{ 'Month' | t }}" type="number" onKeyPress="if(this.value.length==2) return false;" formControlName="expDateMonth" />
    </mat-form-field>

    <mat-form-field style="width: 45%">
      <input matInput required placeholder="{{ 'Year' | t }}" type="number" onKeyPress="if(this.value.length==4) return false;" formControlName="expDateYear" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <input matInput required placeholder="{{ 'Amount' | t }}" type="number" formControlName="amount" />
    </mat-form-field>
  </form>

  <button mat-raised-button class="form-submit-button" (click)="submitCreditCardData()" [disabled]="!creditcardDatas.valid">{{ 'Pay' | t }}</button>
</div>
